import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  userLoginReducer,
  adminLoginReducer,
  // userProfileReducer,
  // updateProfileReducer,
  // editUserReducer,
  getProfileDetails,
  userProfileUpdate,
  contactUsReducer,
} from "./reducers/userReducers";
import {
  orderReducer,
  orderAdminReducer,
  getOrderByIdReducer,
  approveOrderReducer,
  markPickedOrderReducer,
  cancelOrderReducer,
  getDeliveredOrderReducer,
  savePickupInfoReducer,
  saveDropoffInfoReducer,
  saveLengthReducer,
  saveHeigthReducer,
  saveWidthReducer,
  saveCourierInfoReducer,
  savePaymentInfoReducer,
  placeOrderReducer,
  markDeliveredOrderReducer,
  getLatLngReducer,
  getDirectionReducer,
} from "./reducers/orderReducers";

const reducer = combineReducers({
  // userProfile: userProfileReducer,
  // updateProfile: updateProfileReducer,
  // editUser: editUserReducer,
  userLogin: userLoginReducer,
  adminLoginReducer,
  userDetails: getProfileDetails,
  profileUpdate: userProfileUpdate,
  contactUs: contactUsReducer,
  order: orderReducer,
  orderAdmin: orderAdminReducer,
  getOrderById: getOrderByIdReducer,
  approvedOrder: approveOrderReducer,
  markPickedOrder: markPickedOrderReducer,
  cancelOrder: cancelOrderReducer,
  markDeliveredOrder: markDeliveredOrderReducer,
  getDeliveredOrder: getDeliveredOrderReducer,

  savePickup: savePickupInfoReducer,
  saveDropoff: saveDropoffInfoReducer,
  saveLength: saveLengthReducer,
  saveHeigth: saveHeigthReducer,
  saveWidth: saveWidthReducer,
  saveCourier: saveCourierInfoReducer,
  savePaymentInfo: savePaymentInfoReducer,
  placeOrder: placeOrderReducer,

  getLatLngReducer,
  getDirectionReducer,
});

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const initialState = {
  userProfile: { user: {} },
  userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
